const FOpticaTel = [
  {
    id: 1,
    megas: "25",
    titulomeg: "Megas",
    precio: "$441",
    tiempo: " /al mes",
    incluye: [
      "Servicio de fibra óptica",
      "Internet ilimitado",
      "Línea telefónica",
    ],
    titleButton: "Me interesa",
    folioPaquete: "Folio de inscripción: 2394369",
    hrefButton:
      "https://api.whatsapp.com/send?phone=+527731633306&text=Hola me interesa el paquete de 25 megas Fibra Óptica más Telefonía",
    styleCardHeader: [
      {
        id: 1,
        styleHeader: "w-full md:h-24 bg-casper rounded-t-lg",
        styleTextHead: "text-white text-7xl font-bold text-center p-1",
        styleMeg: "text-lg",
      },
    ],
    styleBodyCard: [
      {
        id: 1,
        styleContPrice:
          "md:w-72 p-3 text-center bg-cerulean text-white rounded-lg",
        styleTextPrice: "text-4xl font-bold",
        styleMes: "text-lg",
        styleItemIcon: "text-casper",
      },
    ],
    styleFooter: [
      {
        id: 1,
        styleButton:
          "bg-casper text-white py-2 xl:w-80 md:w-72 sm:w-52 text-xl text-center font-bold rounded-lg",
      },
    ],
  },
  {
    id: 2,
    megas: "60",
    titulomeg: "Megas",
    precio: "$522",
    tiempo: " /al mes",
    incluye: [
      "Servicio de fibra óptica",
      "Internet ilimitado",
      "Línea telefónica",
    ],
    titleButton: "Me interesa",
    folioPaquete: "Folio de inscripción: 2394423",
    hrefButton:
      "https://api.whatsapp.com/send?phone=+527731633306&text=Hola me interesa el paquete de 60 megas Fibra Óptica más Telefonía",
    styleCardHeader: [
      {
        id: 1,
        styleHeader: "w-full md:h-24 bg-casper rounded-t-lg",
        styleTextHead: "text-white text-7xl font-bold text-center p-1",
        styleMeg: "text-lg",
      },
    ],
    styleBodyCard: [
      {
        id: 1,
        styleContPrice:
          "md:w-72 p-3 text-center bg-cerulean text-white rounded-lg",
        styleTextPrice: "text-4xl font-bold",
        styleMes: "text-lg",
        styleItemIcon: "text-casper",
      },
    ],
    styleFooter: [
      {
        id: 1,
        styleButton:
          "bg-casper text-white py-2 xl:w-80 md:w-72 sm:w-52 text-xl text-center font-bold rounded-lg",
      },
    ],
  },
  {
    id: 3,
    megas: "70",
    titulomeg: "Megas",
    precio: "$580",
    tiempo: " /al mes",
    incluye: [
      "Servicio de fibra óptica",
      "Internet ilimitado",
      "Línea telefónica",
    ],
    titleButton: "Me interesa",
    folioPaquete: "Folio de inscripción: 2394445",
    hrefButton:
      "https://api.whatsapp.com/send?phone=+527731633306&text=Hola me interesa el paquete de 70 megas Fibra Óptica más Telefonía",
    styleCardHeader: [
      {
        id: 1,
        styleHeader: "w-full md:h-24 bg-casper rounded-t-lg",
        styleTextHead: "text-white text-7xl font-bold text-center p-1",
        styleMeg: "text-lg",
      },
    ],
    styleBodyCard: [
      {
        id: 1,
        styleContPrice:
          "md:w-72 p-3 text-center bg-cerulean text-white rounded-lg",
        styleTextPrice: "text-4xl font-bold",
        styleMes: "text-lg",
        styleItemIcon: "text-casper",
      },
    ],
    styleFooter: [
      {
        id: 1,
        styleButton:
          "bg-casper text-white py-2 xl:w-80 md:w-72 sm:w-52 text-xl text-center font-bold rounded-lg",
      },
    ],
  },
  {
    id: 4,
    megas: "100",
    titulomeg: "Megas",
    precio: "$870",
    tiempo: " /al mes",
    incluye: [
      "Servicio de fibra óptica",
      "Internet ilimitado",
      "Línea telefónica",
    ],
    titleButton: "Me interesa",
    folioPaquete: "Folio de inscripción: 2394460",
    hrefButton:
      "https://api.whatsapp.com/send?phone=+527731633306&text=Hola me interesa el paquete de 100 megas Fibra Óptica más Telefonía",
    styleCardHeader: [
      {
        id: 1,
        styleHeader: "w-full md:h-24 bg-casper rounded-t-lg",
        styleTextHead: "text-white text-7xl font-bold text-center p-1",
        styleMeg: "text-lg",
      },
    ],
    styleBodyCard: [
      {
        id: 1,
        styleContPrice:
          "md:w-72 p-3 text-center bg-cerulean text-white rounded-lg",
        styleTextPrice: "text-4xl font-bold",
        styleMes: "text-lg",
        styleItemIcon: "text-casper",
      },
    ],
    styleFooter: [
      {
        id: 1,
        styleButton:
          "bg-casper text-white py-2 xl:w-80 md:w-72 sm:w-52 text-xl text-center font-bold rounded-lg",
      },
    ],
  },
];

export default FOpticaTel;
